module.exports = __webpack_public_path__ + "static/img/map-point.79b7b7bf.svg";